module.exports = __webpack_public_path__ + "static/water_nubian1-c79cf5d7b6e3216cf13c10fc0c279cf6.jpg";